import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";

const cashWalletSlice = createSlice({
  name: "cashWallet",

  initialState: {
    cashWalletData: [],
    cashAmount: null,
    isError: false,
  },

  reducers: {
    fetchCashWalletSuccess: (state, action) => {
      state.isError = false;
      state.cashWalletData = action.payload;
    },
    fetchCashAmount: (state, action) => {
      state.isError = false;
      state.cashAmount = action.payload;
    },
    fetchCashWalletFailure: (state) => {
      state.isError = true;
    },
    resetCashWallet: (state) => {
      state.cashWalletData = [];
      state.cashAmount = null;
      state.isError = false;
    },
  },
});

export const {
  fetchCashWalletSuccess,
  fetchCashAmount,
  fetchCashWalletFailure,
  resetCashWallet,
} = cashWalletSlice.actions;

export const fetchCashWallet = (logout) => async (dispatch) => {
  try {
    const response = await axios.get(`${config.apiUrl}/cash-wallet`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: config.token,
        Accept: "application/json",
      },
    });

    dispatch(fetchCashAmount(response.data.cash_balance));
    dispatch(fetchCashWalletSuccess(response.data.transaction.data));
  } catch (error) {
    dispatch(fetchCashWalletFailure());
    if (error.response && error.response.status === 401) {
      logout();
    }
  }
};

export default cashWalletSlice.reducer;
